

























import Vue, { PropType } from "vue";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Overlay,
    Button,
    ButtonConfig,
    Caption,
    Heading
  },
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    bodyType: {
      type: String as PropType<Props["bodyType"]>,
      default: "text"
    },
    closeLabel: {
      type: String,
      default: "閉じる"
    }
  },
  methods: {
    handleClick() {
      this.$emit("close");
    }
  }
});
